import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { captureAttribution } from './utils/attribution.js';
import './style.css';
import './responsive.css';
import './chrome.css';
import './inner.css';

// Record the visitor's inbound origin before the app renders so every CTA can
// carry it. Self-guarded — a storage failure here is a no-op, never a throw.
captureAttribution();

const rootEl = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Prerendered routes ship real HTML in #root → hydrate it. In dev (empty shell)
// there's nothing to hydrate, so client-render instead.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, app);
} else {
  ReactDOM.createRoot(rootEl).render(app);
}
